import { firebase, googleAuthProvider } from '../firebase/firebase'
export const startLogin = () => {
    return () => {
        return firebase.auth().signInWithPopup(googleAuthProvider)
    }
}

// export const editLogin = (userProfile) => ({
//     type: 'EDIT_LOGIN',
//     ...userProfile
// })


export const login = (userProfile) => ({
    type: 'LOGIN',
    ...userProfile
})


export const startLogout = () => {
    return () => {

        return firebase.auth().signOut();
    }
}

export const logout = () => ({
    type: 'LOGOUT'
})


// WEBPACK FOOTER //
// ./src/actions/auth.js